import { render } from "./ProfileNewsList.vue?vue&type=template&id=b7667d66"
import script from "./ProfileNewsList.vue?vue&type=script&lang=js"
export * from "./ProfileNewsList.vue?vue&type=script&lang=js"

import "./ProfileNewsList.vue?vue&type=style&index=0&id=b7667d66&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__